import { CHANGE_THEME } from './configuration/actions';
const initialState = localStorage.getItem('theme') || 'light';
export default (previousState = initialState, { type, payload }) => {
  if (type === CHANGE_THEME) {
    localStorage.setItem('theme', payload);
    return payload;
  }
  return previousState;
};
